    import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthModalOpen: false,
    isOtpModalOpen: false,
    isSelectionOpen: false,
    isRegistrationOpen: false,
    authMode: 'login', 
    flow: 'mobile',    
    identity: '',      
  },
  reducers: {
    openAuthModal: (state, action) => {
      state.isAuthModalOpen = true;
      state.isOtpModalOpen = false;
      state.isSelectionOpen = false;
      state.authMode = action.payload || 'login';
    },
    switchToOtp: (state, action) => {
      state.isAuthModalOpen = false;
      state.isOtpModalOpen = true;
      state.flow = action.payload.flow;
      state.identity = action.payload.identity;
    },
    switchToSelection: (state) => {
      state.isOtpModalOpen = false; // OTP band karo
      state.isSelectionOpen = true; // Selection kholo
    },
    switchToRegistration: (state) => {
      state.isSelectionOpen = false; // Selection band karo
      state.isRegistrationOpen = true; // Registration kholo
    },
    closeAllModals: (state) => {
      state.isAuthModalOpen = false;
      state.isOtpModalOpen = false;
      state.isSelectionOpen = false;
      state.isRegistrationOpen = false;
      state.identity = '';
    }
  }
});

export const { openAuthModal, switchToOtp,switchToSelection,switchToRegistration, closeAllModals } = authSlice.actions;
export default authSlice.reducer;